import { useState, useEffect, useCallback } from "react";
import MenuService from "../../../rest/menuService";
import ProductService from "../../../rest/productService";
import ComboService from "../../../rest/comboService";
import { useRealTimeList } from "../../../ws/useRealtimeList";

export function useMenuData(itemType, filters, page, pageSize, sort, user) {
    const [pagedData, setPagedData] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);

    const wsType = itemType === 'Receita' ? 'recipe'
        : itemType === 'Produto' ? 'product'
            : 'combo';

    useRealTimeList({
        clientCode: user?.client_code || user?.clientCode || sessionStorage.getItem("clientCode"),
        clientType: wsType,
        setPagedData: setPagedData,
        setTotalElements: setTotalElements
    });

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const apiFilters = {};

            if (filters.categories?.length > 0) {
                apiFilters.categories = filters.categories.map(c => c.value || c);
            }

            if (itemType === 'Produto') {
                apiFilters.active = true;
            } else if (filters.status?.length === 1) {
                const val = filters.status[0]?.value ?? filters.status[0];
                if (val !== null) apiFilters.active = val;
            }

            if (filters.minPrice) apiFilters.minPrice = filters.minPrice;
            if (filters.maxPrice) apiFilters.maxPrice = filters.maxPrice;

            const queryParams = {
                search: filters.search || '',
                ...apiFilters,

                page: page,
                size: pageSize,
                sort: sort
            };

            let response;
            if (itemType === 'Receita') response = await MenuService.getAllRecipes(queryParams);
            else if (itemType === 'Produto') response = await ProductService.getAllProducts(queryParams);
            else if (itemType === 'Combo') response = await ComboService.getAllCombos(queryParams);

            if (response) {
                setPagedData(response.content || []);
                setTotalPages(response.totalPages || 0);
                setTotalElements(response.totalElements || 0);
            }
        } catch (error) {
            console.error("Erro ao carregar menu:", error);
        } finally {
            setLoading(false);
        }
    }, [itemType, filters, page, pageSize, sort]);

    useEffect(() => {
        const timeout = setTimeout(fetchData, 300);
        return () => clearTimeout(timeout);
    }, [fetchData]);

    return { pagedData, totalElements, totalPages, loading };
}